"use client"

import { useAuth } from '@/contexts/AuthContext'

export function useQuickNavLinks(enabled = true) {
	const { quickLinks = [] } = useAuth()
	return enabled ? quickLinks : []
}
